import React, { useEffect, useContext, useState } from "react";
import { Col, Row, Typography } from "antd";

import InputNumberField from "~v2/components/InputNumberField/InputNumberField";

import { PHResidentSection_fields as inputDetails } from "./fields-object/fields-object";
import { OvernighGuestContext as Context } from "./context-form";

const { Paragraph } = Typography;

const Index = () => {
  const { overnightGuestValues } = useContext(Context);
  const [totalMale, settotalMale] = useState();
  const [totalFemale, settotalFemale] = useState();

  useEffect(() => {
    settotalMale(
      (overnightGuestValues?.filipinoForeign?.male || 0) +
        (overnightGuestValues?.filipinoNationality?.male || 0)
    );
    settotalFemale(
      (overnightGuestValues?.filipinoForeign?.female || 0) +
        (overnightGuestValues?.filipinoNationality?.female || 0)
    );
  }, [overnightGuestValues]);
  return (
    <>
      <Row gutter={10} justify="space-between" align="center">
        <Col span={10} />
        <Col span={7}>
          <Paragraph level={4}> Male </Paragraph>
        </Col>
        <Col span={7}>
          <Paragraph level={4}> Female </Paragraph>
        </Col>
      </Row>
      {inputDetails.map((input, index) => {
        return (
          <Row
            key={`row${index}`}
            gutter={10}
            justify="space-between"
            align="center"
          >
            <Col span={10}>
              <Paragraph>{input?.label}</Paragraph>
            </Col>

            {input.types.map((type, _index) => {
              return (
                <Col span={7}>
                  <InputNumberField
                    key={`inputField${_index}`}
                    state={input.state}
                    name={[`${input.name}`, `${type}`]}
                    rules={[
                      {
                        required: true,
                        message: `Please Input ${
                          input.label
                        } ${type.toUpperCase()}`,
                      },
                    ]}
                  />
                </Col>
              );
            })}
          </Row>
        );
      })}

      <Row gutter={10} justify="space-between" align="center">
        <Col span={10}>
          <Paragraph>Total Philippine Residents</Paragraph>
        </Col>
        <Col span={7} style={{ display: "flex", justifyContent: "center" }}>
          <Paragraph>{totalMale}</Paragraph>
        </Col>
        <Col span={7} style={{ display: "flex", justifyContent: "center" }}>
          <Paragraph>{totalFemale}</Paragraph>
        </Col>
      </Row>
      <Row gutter={10} justify="space-between" align="center">
        <Col span={10} />
        <Col span={14} style={{ display: "flex", justifyContent: "center" }}>
          <Paragraph>{(totalMale || 0) + (totalFemale || 0)}</Paragraph>
        </Col>
      </Row>
    </>
  );
};

export default Index;
